import {
  Address,
  Chain,
  createPublicClient,
  createWalletClient,
  custom,
  http,
  parseEther,
  PublicClient,
} from 'viem';
import { publicActionsL1, publicActionsL2, walletActionsL1, walletActionsL2 } from 'viem/op-stack';
import { erc20ABI } from 'wagmi';

import { OptimismPortal } from '../env';
import { bsc, opChain } from '../pages/_app';

interface PublicClientL1Params {
  chain?: Chain;
  provider: any;
}

export const getPublicClientL1 = ({ chain = bsc, provider }: PublicClientL1Params) => {
  return createPublicClient({
    chain,
    transport: custom(provider),
  }).extend(publicActionsL1());
};

interface WalletClientL1Params {
  account: Address;
  chain?: Chain;
  provider: any;
}

export const getWalletClientL1 = ({ account, chain = bsc, provider }: WalletClientL1Params) => {
  return createWalletClient({
    account,
    chain,
    transport: custom(provider),
  }).extend(walletActionsL1());
};

interface PublicClientL2Params {
  chain?: Chain;
  provider?: any;
}

export const getPublicClientL2 = ({ chain = opChain, provider }: PublicClientL2Params) => {
  return createPublicClient({
    chain,
    transport: provider ? custom(provider) : http(),
  }).extend(publicActionsL2());
};

interface WalletClientL2Params {
  account: Address;
  chain?: Chain;
  provider: any;
}

export const getWalletClientL2 = ({ account, chain = opChain, provider }: WalletClientL2Params) => {
  return createWalletClient({
    account,
    chain,
    transport: custom(provider),
  }).extend(walletActionsL2());
};

export const getApproveGas = async ({
  publicClient,
  l1Address,
  amount,
  account,
}: {
  publicClient: PublicClient;
  l1Address: string;
  amount: string;
  account?: Address;
}) => {
  // const gasPrice = await publicClient.getGasPrice();
  const appEstiGas = await publicClient.estimateContractGas({
    address: l1Address as Address,
    abi: erc20ABI,
    functionName: 'approve',
    args: [OptimismPortal as Address, parseEther(amount)],
    account,
  });

  return appEstiGas;
};
